export class NeedsBySchoolResolver {
    static mapNeedsBySchools(needs) {
        const validMatch = ['full', 'potential', 'non-match'];
        const needsCount = {};
        if (!needs) {
            return {};
        }

        const zeroCount = Object.fromEntries(Object.keys(needs).map(match => [match, 0]));
        Object.keys(needs).forEach((match) => {
            if (!validMatch.includes(match)) {
                return;
            }

            // the needs endpoint returns empty arrays when there's no results.
            const iterable = Array.isArray(needs[match]) ? [] : Object.keys(needs[match]);
            iterable.forEach(year => {
                Object.keys(needs[match][year]).forEach(position => {
                    needs[match][year][position].forEach(schoolId => {
                        if (!needsCount.hasOwnProperty(schoolId)) {
                            needsCount[schoolId] = { ...zeroCount };
                        }
                        needsCount[schoolId][match]++;
                    })
                });
            })
        });
        return needsCount;
    }

}
